import DopeUI, { TERMINAL } from '../ui/DopeOS-UI';
import { DopeTextRenderer } from '../renderer/bitmapFont';

function text(ctx, value, x, y, color = TERMINAL.TEXT) {
  ctx.fillStyle = color;
  DopeTextRenderer.renderDOSText(ctx, value, x, y, 1);
}

function hit(list, id, x, y, w, h, onClick) {
  list.push({ id, x, y, w, h, onClick });
}

function money(value) {
  return value?.amount == null ? '--' : `$${value.amount}`;
}

/**
 * Truthful quote movement versus the server's last trade for this asset,
 * district and player. Never call this a previous-day delta.
 *
 * @param {Object|null} quote
 * @returns {string}
 */
export function deltaLabel(quote) {
  const raw = quote?.priceDeltaBps;
  if (raw == null) return 'NO PRIOR TRADE';
  const bps = Number(raw);
  if (!Number.isFinite(bps)) return '--';
  const arrow = bps > 0 ? '▲' : bps < 0 ? '▼' : '=';
  return `${arrow} ${Math.abs(bps / 100).toFixed(1)}%`;
}

export function drawTradeDialog(ctx, screen, asset, state, quote, actions) {
  const hits = [];
  const w = Math.min(424, screen.width - 16);
  const h = Math.min(288, screen.height - 16);
  const x = Math.floor((screen.width - w) / 2);
  const y = Math.floor((screen.height - h) / 2);

  ctx.save();
  ctx.globalAlpha = 0.78;
  ctx.fillStyle = TERMINAL.BLACK;
  ctx.fillRect(0, 0, screen.width, screen.height);
  ctx.restore();

  DopeUI.Panel(ctx, x, y, w, h, `CONFIRM // ${state.side} ${asset?.name || '--'}`);
  const innerX = x + 14;
  let cursorY = y + 30;

  text(ctx, `${state.side} ${state.qty} ${asset?.name || '--'}`, innerX, cursorY, TERMINAL.TEXT_BRIGHT);
  cursorY += 18;
  text(ctx, asset?.sub || 'MARKET', innerX, cursorY, TERMINAL.TEXT_DIM);
  cursorY += 24;

  const rows = [
    ['UNIT PRICE', money(quote?.unitPrice)],
    ['SETTLEMENT', money(quote?.total)],
    ['VS LAST TRADE', deltaLabel(quote)],
    ['HEAT', quote ? `+${quote.heatDelta ?? 0}` : '--'],
    ['CASH AFTER', money(quote?.cashAfter)],
    ['COAT AFTER', quote ? `${quote.inventoryAfter ?? '--'}/${quote.capacity ?? '--'}` : '--/--'],
  ];
  rows.forEach(([label, value]) => {
    text(ctx, label, innerX, cursorY, TERMINAL.TEXT_DIM);
    text(ctx, value, innerX + 160, cursorY, TERMINAL.TEXT_BRIGHT);
    cursorY += 17;
  });

  const disabled = quote?.disabledReasons?.[0];
  const failure = state.error || state.quoteError || null;
  const message = failure
    ? failure
    : disabled
      ? disabled.message.toUpperCase()
      : state.loading
        ? 'EXECUTING...'
        : quote
          ? 'QUOTE // CONFIRM TO DEAL'
          : 'AWAITING PRICE';
  ctx.fillStyle = failure || disabled ? TERMINAL.GREEN_DARKEST : TERMINAL.BLACK;
  ctx.fillRect(innerX, cursorY + 2, w - 28, 20);
  text(ctx, message.slice(0, 48), innerX + 6, cursorY + 5, failure || disabled ? TERMINAL.TEXT_BRIGHT : TERMINAL.TEXT_DIM);

  const actionY = y + h - 36;
  DopeUI.Button(ctx, innerX, actionY, 132, 24, 'CANCEL', 'normal');
  const canExecute = !!quote?.canExecute && !state.loading;
  DopeUI.Button(ctx, x + w - 164, actionY, 136, 24, state.loading ? 'EXECUTING' : 'EXECUTE', canExecute ? 'hover' : 'disabled');
  hit(hits, 'trade-cancel', innerX, actionY, 132, 24, actions.cancel);
  if (canExecute) hit(hits, 'trade-execute', x + w - 164, actionY, 136, 24, actions.execute);

  return hits;
}

export default drawTradeDialog;
